import { createSelector } from 'reselect'

import {
  selectCurrentConversationContactId,
  selectCurrentCustomerId,
} from 'selectors/tickets'

import { memoize } from 'util/memoization'

import { CONTACT_PAGE } from '../../pages'
import { selectContactsById } from './base'

export function selectContactPageContactId(state) {
  if (state.location.type === CONTACT_PAGE) {
    return state.location.payload.id || null
  }
  return null
}

export const selectCurrentContactId = createSelector(
  selectContactPageContactId,
  selectCurrentConversationContactId,
  (contactPageContactId, conversationContactId) => {
    return contactPageContactId || conversationContactId
  }
)

export const selectCurrentContactIdOrCustomerId = createSelector(
  selectCurrentContactId,
  selectCurrentCustomerId,
  (contactId, customerId) => {
    return contactId || customerId
  }
)

const justContactId = memoize(id => ({ id }))

export const selectCurrentContact = createSelector(
  selectCurrentContactId,
  selectContactsById,
  (id, byId) => {
    return id ? byId[id] : justContactId(id)
  }
)
